  <template>
  <div class="category">
    <Breadcrumbs />
    <div v-if="category.is_anchor">
      <div v-if="category.display_mode === 'PAGE'">
        <div class="wrapper with-sidebar mt-5 mb-5 pb-5">
          <ProductFilter class="col-lg-3 cst-3" />
          <ProductsListingV2 />
        </div>
      </div>
      <div v-if="category.display_mode === 'PRODUCTS'">
        <div class="wrapper with-sidebar mt-5 mb-5 pb-5">
          <ProductFilter class="col-lg-3 cst-3" />
          <ProductsListingV2 />
        </div>
      </div>
      <div class="row" v-if="category.display_mode === 'PRODUCTS_AND_PAGE'">
        <div class="wrapper with-sidebar mt-5 mb-5 pb-5">
          <ProductFilter class="col-lg-3 cst-3" />
          <ProductsListingV2 />
        </div>
      </div>
    </div>
    <div v-else>
      <div class="wrapper with-sidebar mt-5 mb-5 pb-5">
        <ProductFilter class="col-lg-3 cst-3" />
        <ProductsListingV2 />
      </div>
    </div>
    <div v-if="categoryForm != null">
      <dynamic-forms :category_id="category.id" type="category" />
    </div>
  </div>
</template>

<script>
import Breadcrumbs from "@/esf_antarctica_lederhosenland/core/components/breadcrumb/Breadcrumbs";
import ProductFilter from "@/esf_antarctica_lederhosenland/core/components/category-product/ProductFilter";
/*import CategoryDescription from "@/esf_antarctica_lederhosenland/core/components/category-product/CategoryDescription.vue";
import CategoryOverview from "@/esf_antarctica_lederhosenland/core/components/category-product/CategoryOverview.vue";*/
import ProductsListingV2 from "@/esf_antarctica_lederhosenland/core/components/category-product/ProductListingV2";
/*import DynamicForms from "@/esf_antarctica_lederhosenland/core/components/common/DynamicForms.vue";
import AdvertisingBanner from "@/esf_antarctica_lederhosenland/core/components/category-product/AdvertisingBanner.vue";
import VRuntimeTemplate from "v-runtime-template";*/
import config from "@config";

import { Logger } from "@storefront/core/lib/logger";
//import { isServer } from "@storefront/core/helpers";
export default {
  name: "CategoryOverviews",
  components: {
    Breadcrumbs,
    ProductFilter,
    ProductsListingV2,
    /*CategoryDescription,
    CategoryOverview,
    DynamicForms,
    AdvertisingBanner,
    VRuntimeTemplate,*/
    // CategoryPageContentFilter
  },
  computed: {
    category() {
      return this.$store.getters["category/getCurrentCategory"];
    },
    categoryId() {
      return this.$store.getters["category/getCurrentCategoryId"];
    },
    categories() {
      return this.category.children;
    },
    categoryForm() {
      return this.$store.getters["forms/getCategoryForm"];
    },
    gtmProducts() {
      return this.$store.getters["category/getGtmProducts"];
    },
    ga4Products() {
      return this.$store.getters["category/getGa4Products"];
    },
  },
  watch: {
    $route(to, from) {
      if (to.path !== from.path) {
        const query = {};
        const pageSize = config.products?.perPage || 12;
        const perPage = this.$store.getters["category/getProductsPerPage"];
        if (pageSize != perPage) query["page-size"] = perPage;
        this.$router.push({ path: to.path, query: query });
      }
    },
    gtmProducts() {
      Logger.debug("this.$gtm.enabled()", "gtmProducts", this.$gtm.enabled())();
      if (this.$gtm.enabled()) {
        Logger.debug(
          "this.gtmProducts.length",
          "gtmProducts",
          this.gtmProducts.length
        )();
        if (!this.$gtm.uaDisabled) {
          if (this.gtmProducts.length > 0) {
            window.dataLayer.push({
              event: "eec.impressionView",
              ecommerce: {
                impressions: this.gtmProducts,
              },
            });
          }
        }
        if (this.$gtm.ga4Enabled) {
          window.dataLayer.push({
            event: "view_item_list",
            ecommerce: {
              item_list_id: "category",
              item_list_name: this.category.name,
              items: this.ga4Products,
            },
          });
        }
      }
    },
    /*
    categoryId(oldV, newV) {
     
      if (oldV != newV) {
        Logger.debug("CategoryId watch", "Category.vue", this.categoryId)();
        this.$store.dispatch("category/loadProducts");
      }
      
    },
    */
  },
  mounted() {
    /*
    if (!isServer) {
      Logger.debug("MOUNTED", "Category.vue", this.categoryId)();
      if (this.categoryId != 0) {
        this.$store.dispatch("category/loadProducts");
      }
    }
    */
  },
  destroyed() {
    Logger.debug("DESTROYED", "Category.vue", this.categoryId)();
    this.$store.commit("category/setLoadProducts", false);
  },
  methods: {
    unescape(str){
      return str.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '');
    }
  },
  data() {
    return {
      //    bannerBg: bannerImage,
      //categories: mockCategory,
    };
  },
  metaInfo() {
    return {
      meta: [
        { charset: "utf-8" },
        { name: "viewport", content: "width=device-width, initial-scale=1" },
        {
          name: "title",
          content: this.category ? this.category.meta_title : "",
        },
        {
          name: "keywords",
          content: this.category ? this.category.meta_keywords : "",
        },
        {
          name: "description",
          content: this.category ? this.category.meta_description : "",
        },
      ],
      //test 3
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.category.name,
      // all titles will be injected into this template
      link: [
        {
          rel: "canonical",
          href:
            config.app_url +
            (this.category
              ? this.category.canonical_url
              : this.$route.fullPath),
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
</style>